var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifBraking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    fill: "#DB5050",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    stroke: "#DB5050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 5.66406C14.9441 5.66406 17.3307 8.05073 17.3307 10.9974C17.3307 13.9441 14.9441 16.3307 11.9974 16.3307C9.05073 16.3307 6.66406 13.9441 6.66406 10.9974C6.66406 8.05073 9.05073 5.66406 11.9974 5.66406Z",
    stroke: "#DB5050",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80906 5.8125C3.94906 8.67917 3.94906 13.3192 6.80906 16.1858",
    stroke: "#DB5050",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 5.8125C20.0475 8.67917 20.0475 13.3192 17.1875 16.1858",
    stroke: "#DB5050",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.33594V11.0026",
    stroke: "#DB5050",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6641V13.6707",
    stroke: "#DB5050",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBraking);
export default __webpack_public_path__ + "static/media/notif-braking.e78fa57bbc4848a4011e88f7465d4ca7.svg";
export { ForwardRef as ReactComponent };